import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AppBar, Box, Divider, Grid, IconButton, Menu, MenuItem, Toolbar } from '@mui/material';
import NavDrawer from './NavDrawer';
import { useAuth } from '../auth/AuthContext';
import { GAMEPLAY_SESSION_STORAGE_KEY } from '../utils/GameplayDraft';

const Constants = require("../constants/Constants");
let IMAGE_URL = Constants.IMAGE_URL;

export default function NavBar() {
  const navigate = useNavigate();
  const { accessToken, logout } = useAuth();
  const [anchorEl, setAnchorEl] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const open = Boolean(anchorEl);

  const token = accessToken;

  const handleClose = () => setAnchorEl(null);

  const logOut = async () => {
    await logout();
    localStorage.removeItem(GAMEPLAY_SESSION_STORAGE_KEY);
    setAnchorEl(null);
    window.location.href = '/auth';
  };

  const handleDrawerOpen = () => setDrawerOpen(true);
  const handleDrawerClose = () => setDrawerOpen(false);

  let location = useLocation();
  const isLoginScreen = location.pathname === '/auth';
  const showLogo = location.pathname !== "/";

  return (
    <Box sx={{ flexGrow: 1 }}>
      <NavDrawer open={drawerOpen} onClose={handleDrawerClose} />
      {!isLoginScreen && (
        <AppBar position="static" sx={{ background: 'primary.main' }}>
          <Toolbar>
            <Grid container justifyContent="space-between" alignItems="center">
              <Grid item xs={4}></Grid>
              <Grid item xs={4} sx={{ textAlign: 'center' }}>
                {showLogo && (
                  <img
                    loading="lazy"
                    src={`${IMAGE_URL}headers/ASXMarioKart.png`}
                    style={{ width: "125px", paddingTop: 10 }}
                    alt="ASX Mario Kart Title"
                    onClick={event => navigate('/')}
                  />
                )}
              </Grid>
              <Grid item xs={4} sx={{ textAlign: 'right' }}>
                <IconButton
                  size="large"
                  edge="start"
                  color="inherit"
                  aria-label="menu"
                  id="nav-button"
                  aria-controls={open ? 'nav-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? 'true' : undefined}
                  onClick={handleDrawerOpen}
                >
                  <Box>
                    <img
                      loading="lazy"
                      src={`${IMAGE_URL}navigation/Hamburger.png`}
                      style={{ width: "45px" }}
                      alt="hamburger menu"
                    />
                  </Box>
                </IconButton>
                <Menu
                  id="nav-menu"
                  aria-labelledby="nav-button"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                >
                  {token && (  // Check if token exists in cookies
                    <div>
                      <MenuItem onClick={handleClose}>{localStorage.getItem('user')}</MenuItem>
                      <Divider />
                    </div>
                  )}
                  {token && <MenuItem onClick={event => window.location.href = '/grandprix'}>Grand Prix</MenuItem>}
                  {token && <MenuItem onClick={event => window.location.href = '/raceentry'}>Race Entry</MenuItem>}
                  {token && <MenuItem onClick={event => window.location.href = '/roster'}>Roster</MenuItem>}
                  <MenuItem onClick={event => window.location.href = '/stats'}>Stats</MenuItem>
                  {token && (
                    <div>
                      <Divider />
                      <MenuItem onClick={logOut}>Logout</MenuItem>
                    </div>
                  )}
                </Menu>
              </Grid>
            </Grid>
          </Toolbar>
        </AppBar>
      )}
    </Box>
  );
}
